import { SOWItem } from '@/types';

interface ItemsListProps {
  items: SOWItem[];
}

export function ItemsList({ items }: ItemsListProps) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div key={item.id} className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
          <p className="mt-2 text-gray-600">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
